import { useMutation } from "@tanstack/react-query";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { storeCredentials } from "../../../apiClient";
import { auth } from "../firebase";

type FirebaseSignUpOutputDto = {
    accessToken: string;
    refreshToken: string;
};
type FirebaseSignUpInputDto = { email: string; password: string; }
export const useSignUp = (onSuccess: (data: FirebaseSignUpOutputDto) => void) => {
    return useMutation<FirebaseSignUpOutputDto, unknown, FirebaseSignUpInputDto>({
        mutationKey: ['signUp'],
        mutationFn: async (input: FirebaseSignUpInputDto) => {
            const result = await createUserWithEmailAndPassword(auth, input.email, input.password);
            const idToken = await result.user.getIdToken();
            return { accessToken: idToken, refreshToken: result.user.refreshToken };
        },
        onSuccess: (data: FirebaseSignUpOutputDto) => {
            storeCredentials(data.accessToken, data.refreshToken);
            onSuccess(data);
        }
    });
};